module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-text-quote-reece-2.d615875.png";